import { useState, useEffect, useCallback, useRef } from "react";
import Modal from "../../components/Modal";
import Topbar from "../../components/Topbar";
import api from "../../services/api";
import MapaLojistasAtacadistas from "./components/MapaLojistasAtacadistas";

const CATEGORIAS = [
  { key: "TODOS",      label: "Todos" },
  { key: "CONSUMIDOR", label: "Consumidor Final" },
  { key: "ARQ_ENG",    label: "Arq / Eng" },
  { key: "REVENDEDOR", label: "Revendedor" },
  { key: "LOJISTA",    label: "Lojista" },
  { key: "ATACADISTA", label: "Atacadista" },
  { key: "FORNECEDOR", label: "Fornecedor" },
];
const CAT_BADGE = { CONSUMIDOR:"badge-gray", ARQ_ENG:"badge-blue", REVENDEDOR:"badge-amber", LOJISTA:"badge-amber", ATACADISTA:"badge-amber", FORNECEDOR:"badge-blue" };
const STA_BADGE = { ATIVO:"badge-green", INATIVO:"badge-gray", BLOQUEADO:"badge-red", PROSPECCAO:"badge-amber" };

const VAZIO_END = { tipo:"COBRANCA", logradouro:"", numero:"", complemento:"", bairro:"", cidade:"", estado:"", cep:"", principal:true, latitude:"", longitude:"" };
const VAZIO_TEL = { tipo:"TELEFONE", numero:"", nome_contato:"", principal:true };
const VAZIO = { nome:"", razao_social:"", tipo:"PF", categoria:"CONSUMIDOR", cpf:"", cnpj:"", inscricao_estadual:"", email:"", status:"ATIVO", comercializa_similar:false, observacoes:"" };

function endPrincipal(contato) {
  const e = (contato.enderecos||[]).find(x=>x.principal) || (contato.enderecos||[])[0];
  if (!e) return "-";
  return `${e.logradouro}, ${e.numero}${e.cidade ? ", "+e.cidade : ""}${e.estado ? "/"+e.estado : ""}`;
}
function telPrincipal(contato) {
  const t = (contato.telefones||[]).find(x=>x.principal) || (contato.telefones||[])[0];
  return t ? t.numero : "-";
}
function extrairDadosCNPJ(d){
  const est = d.estabelecimento || {};
  const razao = d.razao_social||d.nome||"";
  const fantasia = est.nome_fantasia||d.nome_fantasia||"";
  const email = est.email||d.email||"";
  const cep = (est.cep||"").replace(/\D/g,"");
  const logradouro = `${est.tipo_logradouro||""} ${est.logradouro||""}`.trim();
  const numero = est.numero||"";
  const complemento = est.complemento||"";
  const bairro = est.bairro?.nome || est.bairro || "";
  const cidade = est.municipio?.descricao || est.cidade?.ibge_nome || est.cidade?.nome || "";
  const estado = est.estado?.sigla||"";
  const telefone = (est.ddd1 && est.telefone1) ? `(${est.ddd1}) ${est.telefone1}` : "";
  const inscEstadual = (d.inscricoes_estaduais||[]).find(x=>x.ativo)?.inscricao_estadual
    || (d.inscricoes_estaduais||[])[0]?.inscricao_estadual || "";
  return { razao, fantasia, email, cep, logradouro, numero, complemento, bairro, cidade, estado, telefone, inscEstadual };
}

function LinhaContato({contato, onSalvo, onExcluir}){
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({...contato});
  const [endForm, setEndForm] = useState(
    (contato.enderecos||[])[0] || {...VAZIO_END}
  );
  const [telForm, setTelForm] = useState(
    (contato.telefones||[])[0] || {...VAZIO_TEL}
  );
  const [salvando, setSalvando] = useState(false);
  const [buscandoCNPJ, setBuscandoCNPJ] = useState(false);
  const [buscandoCEP, setBuscandoCEP] = useState(false);
  const [geocodificando, setGeocodificando] = useState(false);

  const setF = (f,v) => setForm(prev=>({...prev,[f]:v}));
  const setE = (f,v) => setEndForm(prev=>({...prev,[f]:v}));
  const setT = (f,v) => setTelForm(prev=>({...prev,[f]:v}));

  const geocodificarEndereco = async (logradouro, numero, cidade, estado) => {
    if(!logradouro || !numero) return;
    setGeocodificando(true);
    try{
      const addr = `${logradouro}, ${numero}, ${cidade||""}, ${estado||""}, Brasil`;
      const res = await fetch("https://nominatim.openstreetmap.org/search?format=json&q="+encodeURIComponent(addr));
      const d = await res.json();
      if(d[0]) setEndForm(prev=>({...prev, latitude:d[0].lat, longitude:d[0].lon}));
    }catch{}
    finally{setGeocodificando(false);}
  };

  const handleCNPJ = async (val) => {
    setF("cnpj", val);
    const nums = val.replace(/\D/g,"");
    if(nums.length !== 14) return;
    setBuscandoCNPJ(true);
    try{
      const res = await fetch("https://publica.cnpj.ws/cnpj/"+nums);
      if(!res.ok) return;
      const d = await res.json();
      const dados = extrairDadosCNPJ(d);
      setForm(f=>({...f, nome:dados.fantasia||dados.razao||f.nome, razao_social:dados.razao||"", email:dados.email||f.email||"", inscricao_estadual: dados.inscEstadual||f.inscricao_estadual||""}));
      if(dados.telefone) setTelForm(prev=>({...prev, numero: dados.telefone}));
      if(dados.cep){
        setEndForm(prev=>({...prev, cep: dados.cep, logradouro:dados.logradouro, numero:dados.numero, complemento:dados.complemento, bairro:dados.bairro, cidade:dados.cidade, estado:dados.estado}));
        if(dados.logradouro && dados.numero){
          geocodificarEndereco(dados.logradouro, dados.numero, dados.cidade, dados.estado);
        }
      }
    }catch{}
    finally{setBuscandoCNPJ(false);}
  };

  const handleCEP = async (val) => {
    setE("cep", val);
    const nums = val.replace(/\D/g,"");
    if(nums.length !== 8) return;
    setBuscandoCEP(true);
    try{
      const res = await fetch("https://viacep.com.br/ws/"+nums+"/json/");
      const d = await res.json();
      if(!d.erro){
        setEndForm(prev=>({...prev, logradouro:d.logradouro||"", bairro:d.bairro||"", cidade:d.localidade||"", estado:d.uf||""}));
        if(endForm.numero && d.logradouro){
          geocodificarEndereco(d.logradouro, endForm.numero, d.localidade, d.uf);
        }
      }
    }catch{}
    finally{setBuscandoCEP(false);}
  };

  const handleNumeroBlur = () => {
    if(endForm.logradouro && endForm.numero && endForm.cidade && endForm.estado){
      geocodificarEndereco(endForm.logradouro, endForm.numero, endForm.cidade, endForm.estado);
    }
  };

  const handleGeo = () => geocodificarEndereco(endForm.logradouro, endForm.numero, endForm.cidade, endForm.estado);

  const salvar = async (e) => {
    e.stopPropagation();
    setSalvando(true);
    try{
      await api.put("/clientes/contatos/"+contato.id+"/", form);
      if(endForm.logradouro){
        const endExist = (contato.enderecos||[])[0];
        if(endExist) await api.put("/clientes/enderecos/"+endExist.id+"/", {...endForm, contato:contato.id});
        else await api.post("/clientes/enderecos/", {...endForm, contato:contato.id});
      }
      if(telForm.numero){
        const telExist = (contato.telefones||[])[0];
        if(telExist) await api.put("/clientes/telefones/"+telExist.id+"/", {...telForm, contato:contato.id});
        else await api.post("/clientes/telefones/", {...telForm, contato:contato.id});
      }
      onSalvo();
      setOpen(false);
    }catch(err){alert("Erro ao salvar: "+JSON.stringify(err.response?.data||err.message));}
    finally{setSalvando(false);}
  };

  const catLabel = CATEGORIAS.find(x=>x.key===contato.categoria)?.label||contato.categoria;
  const catBadge = "badge " + (CAT_BADGE[contato.categoria]||"badge-gray");
  const staBadge = "badge " + (STA_BADGE[contato.status]||"badge-gray");

  return(
    <>
      <tr className="tr-expandable" onClick={()=>setOpen(o=>!o)}>
        <td>
          <strong>{contato.nome}</strong>
          {contato.razao_social&&<div style={{fontSize:11,color:"var(--z-text-secondary)"}}>{contato.razao_social}</div>}
          {(contato.cnpj||contato.cpf)&&<div style={{fontSize:11,color:"var(--z-text-muted)"}}>{contato.cnpj||contato.cpf}</div>}
        </td>
        <td><span className={catBadge}>{catLabel}</span></td>
        <td><span className="badge badge-gray">{contato.tipo}</span></td>
        <td style={{color:"var(--z-text-secondary)",fontSize:12}}>{telPrincipal(contato)}</td>
        <td style={{color:"var(--z-text-secondary)",fontSize:12,maxWidth:200}}>{endPrincipal(contato)}</td>
        <td style={{color:"var(--z-text-secondary)",fontSize:12}}>{contato.email||"-"}</td>
        <td><span className={staBadge}>{contato.status}</span></td>
        <td style={{textAlign:"right"}}><i className={"ti ti-chevron-"+(open?"up":"down")} style={{fontSize:14,color:"var(--z-text-muted)"}}/></td>
      </tr>
      {open&&(
        <tr className="tr-dropdown">
          <td colSpan={8}>
            <div className="dropdown-content" onClick={e=>e.stopPropagation()}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:8}}>
                <div className="form-group">
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={form.tipo||"PF"} onChange={e=>setF("tipo",e.target.value)}>
                    <option value="PF">Pessoa Fisica</option>
                    <option value="PJ">Pessoa Juridica</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Categoria</label>
                  <select className="form-select" value={form.categoria||""} onChange={e=>setF("categoria",e.target.value)}>
                    {CATEGORIAS.filter(c=>c.key!=="TODOS").map(c=><option key={c.key} value={c.key}>{c.label}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Status</label>
                  <select className="form-select" value={form.status||"ATIVO"} onChange={e=>setF("status",e.target.value)}>
                    <option value="ATIVO">Ativo</option>
                    <option value="INATIVO">Inativo</option>
                    <option value="BLOQUEADO">Bloqueado</option>
                    <option value="PROSPECCAO">Prospeccao</option>
                  </select>
                </div>
                <div className="form-group" style={{display:"flex",alignItems:"center",gap:6,marginTop:20}}>
                  <input type="checkbox" id={"similar-"+contato.id} checked={!!form.comercializa_similar} onChange={e=>setF("comercializa_similar",e.target.checked)}/>
                  <label htmlFor={"similar-"+contato.id} className="form-label" style={{marginBottom:0}}>Ja comercializa similar (varal)</label>
                </div>
                {form.tipo==="PJ"?(
                  <div className="form-group">
                    <label className="form-label">CNPJ {buscandoCNPJ&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Buscando...</span>}</label>
                    <input className="form-input" value={form.cnpj||""} placeholder="00.000.000/0000-00" onChange={e=>handleCNPJ(e.target.value)}/>
                  </div>
                ):(
                  <div className="form-group">
                    <label className="form-label">CPF</label>
                    <input className="form-input" value={form.cpf||""} placeholder="000.000.000-00" onChange={e=>setF("cpf",e.target.value)}/>
                  </div>
                )}
                <div className="form-group" style={{gridColumn:"span 2"}}>
                  <label className="form-label">Nome</label>
                  <input className="form-input" value={form.nome||""} onChange={e=>setF("nome",e.target.value)}/>
                </div>
                {form.tipo==="PJ"&&<div className="form-group" style={{gridColumn:"span 2"}}><label className="form-label">Razao social</label><input className="form-input" value={form.razao_social||""} onChange={e=>setF("razao_social",e.target.value)}/></div>}
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input className="form-input" type="email" value={form.email||""} onChange={e=>setF("email",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Telefone</label>
                  <input className="form-input" value={telForm.numero||""} onChange={e=>setT("numero",e.target.value)} placeholder="(11) 99999-9999"/>
                </div>
                <div className="form-group">
                  <label className="form-label">Insc. Estadual</label>
                  <input className="form-input" value={form.inscricao_estadual||""} onChange={e=>setF("inscricao_estadual",e.target.value)}/>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:8}}>
                <div className="form-group">
                  <label className="form-label">Tipo endereco</label>
                  <select className="form-select" value={endForm.tipo||"COBRANCA"} onChange={e=>setE("tipo",e.target.value)}>
                    <option value="COBRANCA">Cobranca</option>
                    <option value="ENTREGA">Entrega</option>
                    <option value="SERVICO">Servico</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">CEP {buscandoCEP&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:6}}>buscando...</span>}</label>
                  <input className="form-input" value={endForm.cep||""} placeholder="00000-000" onChange={e=>handleCEP(e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Numero</label>
                  <input className="form-input" value={endForm.numero||""} onChange={e=>setE("numero",e.target.value)} onBlur={handleNumeroBlur}/>
                </div>
                <div className="form-group" style={{gridColumn:"span 2"}}>
                  <label className="form-label">Logradouro</label>
                  <input className="form-input" value={endForm.logradouro||""} onChange={e=>setE("logradouro",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Complemento</label>
                  <input className="form-input" value={endForm.complemento||""} onChange={e=>setE("complemento",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Bairro</label>
                  <input className="form-input" value={endForm.bairro||""} onChange={e=>setE("bairro",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Cidade</label>
                  <input className="form-input" value={endForm.cidade||""} onChange={e=>setE("cidade",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Estado</label>
                  <input className="form-input" value={endForm.estado||""} onChange={e=>setE("estado",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Latitude</label>
                  <input className="form-input" value={endForm.latitude||""} onChange={e=>setE("latitude",e.target.value)} placeholder="-23.550500"/>
                </div>
                <div className="form-group">
                  <label className="form-label">Longitude</label>
                  <input className="form-input" value={endForm.longitude||""} onChange={e=>setE("longitude",e.target.value)} placeholder="-46.633300"/>
                </div>
                <div className="form-group" style={{display:"flex",alignItems:"flex-end",gap:8,gridColumn:"span 2"}}>
                  <button className="btn btn-secondary" onClick={handleGeo}>
                    <i className="ti ti-map-pin"/> {geocodificando?"Buscando...":"Buscar coordenadas automaticamente"}
                  </button>
                </div>
              </div>
              <div className="form-group" style={{gridColumn:"span 4",marginBottom:0}}>
                <textarea className="form-input" rows={1} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/>
              </div>
              <div className="produto-dropdown-acoes">
                <button className="btn btn-primary" disabled={salvando} onClick={salvar}>
                  <i className="ti ti-check"/> {salvando?"Salvando...":"Salvar"}
                </button>
                <button className="btn btn-danger" onClick={e=>{e.stopPropagation();onExcluir(contato.id);}}>
                  <i className="ti ti-trash"/> Excluir
                </button>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

export default function ClientesLista() {
  const [contatos, setContatos]     = useState([]);
  const [contagens, setContagens]   = useState({});
  const [buscaInput, setBuscaInput] = useState("");
  const [busca, setBusca]           = useState("");
  const [aba, setAba]               = useState("TODOS");
  const [pagina, setPagina]         = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading]       = useState(true);
  const [modalForm, setModalForm]   = useState(null);
  const [form, setForm]             = useState(VAZIO);
  const [endForm, setEndForm]       = useState(VAZIO_END);
  const [telForm, setTelForm]       = useState(VAZIO_TEL);
  const [salvando, setSalvando]     = useState(false);
  const [buscandoCNPJ, setBuscandoCNPJ] = useState(false);
  const [buscandoCEP, setBuscandoCEP]   = useState(false);
  const [geocodificando, setGeocodificando] = useState(false);
  const [verMapa, setVerMapa]       = useState(false);

  const PAGE_SIZE = 30;
  const totalPaginas = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));

  const debounceRef = useRef(null);
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setPagina(1);
      setBusca(buscaInput);
    }, 400);
    return () => clearTimeout(debounceRef.current);
  }, [buscaInput]);

  const carregar = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams({ page: pagina, page_size: PAGE_SIZE });
    if (aba !== "TODOS") params.set("categoria", aba);
    if (busca) params.set("busca", busca);
    api.get("/clientes/contatos/?" + params.toString())
      .then(res => {
        if (res.data.results) {
          setContatos(res.data.results);
          setTotalCount(res.data.count);
        } else {
          setContatos(res.data);
          setTotalCount(res.data.length);
        }
      })
      .catch(() => { setContatos([]); setTotalCount(0); })
      .finally(() => setLoading(false));
  }, [aba, busca, pagina]);

  const carregarContagens = () => {
    api.get("/clientes/contatos/contagem_por_categoria/")
      .then(res => setContagens(res.data))
      .catch(() => setContagens({}));
  };

  useEffect(() => { if(!verMapa) carregar(); }, [carregar, verMapa]);
  useEffect(() => { carregarContagens(); }, []);

  const mudarAba = (key) => { setAba(key); setPagina(1); };

  const buscarCNPJ = async (cnpj) => {
    const nums = cnpj.replace(/\D/g,"");
    if(nums.length !== 14) return;
    await new Promise(r=>setTimeout(r,500));
    setBuscandoCNPJ(true);
    try {
      const res = await fetch(`https://publica.cnpj.ws/cnpj/${nums}`);
      if(!res.ok) return;
      const d = await res.json();
      const dados = extrairDadosCNPJ(d);
      setForm(f=>({...f, nome: dados.fantasia||dados.razao||f.nome, razao_social: dados.razao||"", email: dados.email||f.email||"", inscricao_estadual: dados.inscEstadual||f.inscricao_estadual||""}));
      if(dados.telefone) setTelForm(prev=>({...prev, numero: dados.telefone}));
      if(dados.cep){
        setEndForm(e=>({...e, logradouro:dados.logradouro, numero:dados.numero, complemento:dados.complemento, bairro:dados.bairro, cidade:dados.cidade, estado:dados.estado, cep:dados.cep}));
        if(dados.logradouro && dados.numero){
          geocodificarEndereco(`${dados.logradouro}, ${dados.numero}, ${dados.cidade}, ${dados.estado}, Brasil`);
        }
      }
    } catch(e){} finally { setBuscandoCNPJ(false); }
  };

  const buscarCEP = async (cep) => {
    const nums = cep.replace(/\D/g,"");
    if(nums.length !== 8) return;
    await new Promise(r=>setTimeout(r,300));
    setBuscandoCEP(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${nums}/json/`);
      const d = await res.json();
      if(d.erro) return;
      setEndForm(f=>({
        ...f,
        logradouro: d.logradouro||f.logradouro,
        bairro: d.bairro||f.bairro,
        cidade: d.localidade||f.cidade,
        estado: d.uf||f.estado,
      }));
      if(endForm.numero && d.logradouro){
        geocodificarEndereco(`${d.logradouro}, ${endForm.numero}, ${d.localidade}, ${d.uf}, Brasil`);
      }
    } catch(e){} finally { setBuscandoCEP(false); }
  };

  const geocodificarEndereco = async (endStr) => {
    if(!endStr) return;
    setGeocodificando(true);
    try {
      const q = encodeURIComponent(endStr);
      const res = await fetch(`https://nominatim.openstreetmap.org/search?q=${q}&format=json&limit=1`);
      const d = await res.json();
      if(d.length>0){
        setEndForm(f=>({...f, latitude:d[0].lat, longitude:d[0].lon}));
      }
    } catch(e){} finally { setGeocodificando(false); }
  };

  const geocodificarAtual = () => {
    const end = `${endForm.logradouro}, ${endForm.numero}, ${endForm.cidade}, ${endForm.estado}, Brasil`;
    geocodificarEndereco(end);
  };

  const handleNumeroBlurModal = () => {
    if(endForm.logradouro && endForm.numero && endForm.cidade && endForm.estado){
      geocodificarAtual();
    }
  };

  const abrirNovo = () => {
    setForm(VAZIO);
    setEndForm(VAZIO_END);
    setTelForm(VAZIO_TEL);
    setModalForm("novo");
  };

  const salvar = async () => {
    setSalvando(true);
    try {
      const res = await api.post("/clientes/contatos/", form);
      const contato = res.data;
      if(endForm.logradouro){
        await api.post("/clientes/enderecos/", {...endForm, contato: contato.id});
      }
      if(telForm.numero){
        await api.post("/clientes/telefones/", {...telForm, contato: contato.id});
      }
      carregar();
      carregarContagens();
      setModalForm(null);
    } catch(e){ alert("Erro ao salvar: "+JSON.stringify(e.response?.data||e.message)); }
    finally { setSalvando(false); }
  };

  const excluir = async (id) => {
    if(!window.confirm("Excluir este contato?")) return;
    await api.delete(`/clientes/contatos/${id}/`);
    carregar();
    carregarContagens();
  };

  const setF = (f,v) => setForm(prev=>({...prev,[f]:v}));
  const setE = (f,v) => setEndForm(prev=>({...prev,[f]:v}));
  const setT = (f,v) => setTelForm(prev=>({...prev,[f]:v}));

  return(
    <>
      <Topbar title="Clientes"/>
      <div className="erp-content">
        <div className="page-toolbar">
          <button className="btn btn-primary" onClick={abrirNovo}><i className="ti ti-plus"/> Novo contato</button>
          <input className="form-input" style={{width:240}} placeholder="Buscar..." value={buscaInput} onChange={e=>setBuscaInput(e.target.value)}/>
          <button className="btn btn-secondary" onClick={()=>setVerMapa(v=>!v)}>
            <i className="ti ti-map"/> {verMapa ? "Voltar para lista" : "Mapa Lojistas/Atacadistas"}
          </button>
        </div>

        {verMapa ? (
          <MapaLojistasAtacadistas onVoltar={()=>setVerMapa(false)}/>
        ) : (
          <>
            <div className="abas-wrapper" style={{marginBottom:16}}>
              <div className="abas">
                {CATEGORIAS.map(cat=>(
                  <button key={cat.key} className={"aba"+(aba===cat.key?" aba-ativa":"")} onClick={()=>mudarAba(cat.key)}>
                    {cat.label} <span className="aba-count">{contagens[cat.key] ?? 0}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="card">
              <div className="table-wrapper">
                {loading?<div className="table-empty">Carregando...</div>:
                contatos.length===0?<div className="table-empty">Nenhum contato encontrado.</div>:(
                  <table>
                    <thead><tr>
                      <th>Nome</th><th>Categoria</th><th>Tipo</th>
                      <th>Telefone</th><th>Endereco</th><th>Email</th><th>Status</th><th></th>
                    </tr></thead>
                    <tbody>
                      {contatos.map(c=>(
                        <LinhaContato key={c.id} contato={c} onSalvo={()=>{carregar();carregarContagens();}} onExcluir={excluir}/>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              {!loading && totalCount > PAGE_SIZE && (
                <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:12,padding:"12px 0"}}>
                  <button className="btn btn-secondary" style={{padding:"4px 10px"}} disabled={pagina<=1} onClick={()=>setPagina(p=>p-1)}>Ã¢â‚¬Â¹ Anterior</button>
                  <span style={{fontSize:13,color:"var(--z-text-secondary)"}}>Pagina {pagina} de {totalPaginas} ({totalCount} contatos)</span>
                  <button className="btn btn-secondary" style={{padding:"4px 10px"}} disabled={pagina>=totalPaginas} onClick={()=>setPagina(p=>p+1)}>Proxima Ã¢â‚¬Âº</button>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {modalForm&&(
        <Modal title={modalForm==="novo"?"Novo contato":"Editar contato"} onClose={()=>setModalForm(null)} size="lg"
          footer={<>
            <button className="btn btn-secondary" onClick={()=>setModalForm(null)}>Cancelar</button>
            <button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button>
          </>}>

          <div className="form-section">Dados principais</div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Tipo</label>
              <select className="form-select" value={form.tipo} onChange={e=>setF("tipo",e.target.value)}>
                <option value="PF">Pessoa Fisica</option>
                <option value="PJ">Pessoa Juridica</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Categoria</label>
              <select className="form-select" value={form.categoria} onChange={e=>setF("categoria",e.target.value)}>
                {CATEGORIAS.filter(c=>c.key!=="TODOS").map(c=><option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
            </div>
            {form.tipo==="PJ"?(
              <div className="form-group" style={{gridColumn:"span 2"}}>
                <label className="form-label">
                  CNPJ
                  {buscandoCNPJ&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Buscando...</span>}
                </label>
                <input className="form-input" value={form.cnpj||""} placeholder="00.000.000/0000-00"
                  onChange={e=>{setF("cnpj",e.target.value); buscarCNPJ(e.target.value);}}/>
              </div>
            ):(
              <div className="form-group" style={{gridColumn:"span 2"}}>
                <label className="form-label">CPF</label>
                <input className="form-input" value={form.cpf||""} placeholder="000.000.000-00" onChange={e=>setF("cpf",e.target.value)}/>
              </div>
            )}
            <div className="form-group" style={{gridColumn:"span 2"}}>
              <label className="form-label">Nome {buscandoCNPJ&&<span style={{fontSize:11,color:"var(--z-blue)"}}>preenchido automaticamente</span>}</label>
              <input className="form-input" value={form.nome||""} onChange={e=>setF("nome",e.target.value)} placeholder="Nome ou razao social"/>
            </div>
            {form.tipo==="PJ"&&(
              <div className="form-group" style={{gridColumn:"span 2"}}>
                <label className="form-label">Razao social</label>
                <input className="form-input" value={form.razao_social||""} onChange={e=>setF("razao_social",e.target.value)}/>
              </div>
            )}
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={form.email||""} onChange={e=>setF("email",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Telefone</label>
              <input className="form-input" value={telForm.numero||""} onChange={e=>setT("numero",e.target.value)} placeholder="(11) 99999-9999"/>
            </div>
            <div className="form-group">
              <label className="form-label">Insc. Estadual</label>
              <input className="form-input" value={form.inscricao_estadual||""} onChange={e=>setF("inscricao_estadual",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Status</label>
              <select className="form-select" value={form.status} onChange={e=>setF("status",e.target.value)}>
                <option value="ATIVO">Ativo</option>
                <option value="INATIVO">Inativo</option>
                <option value="BLOQUEADO">Bloqueado</option>
                <option value="PROSPECCAO">Prospeccao</option>
              </select>
            </div>
            <div className="form-group" style={{display:"flex",alignItems:"center",gap:6,marginTop:20}}>
              <input type="checkbox" id="similar-modal" checked={!!form.comercializa_similar} onChange={e=>setF("comercializa_similar",e.target.checked)}/>
              <label htmlFor="similar-modal" className="form-label" style={{marginBottom:0}}>Ja comercializa similar (varal)</label>
            </div>
          </div>

          <div className="form-section">
            Endereco
            {buscandoCEP&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Buscando CEP...</span>}
            {geocodificando&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Geocodificando...</span>}
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Tipo endereco</label>
              <select className="form-select" value={endForm.tipo} onChange={e=>setE("tipo",e.target.value)}>
                <option value="COBRANCA">Cobranca</option>
                <option value="ENTREGA">Entrega</option>
                <option value="SERVICO">Servico</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">
                CEP
                {buscandoCEP&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:6}}>buscando...</span>}
              </label>
              <input className="form-input" value={endForm.cep||""} placeholder="00000-000"
                onChange={e=>{setE("cep",e.target.value); buscarCEP(e.target.value);}}/>
            </div>
            <div className="form-group" style={{gridColumn:"span 2"}}>
              <label className="form-label">Logradouro</label>
              <input className="form-input" value={endForm.logradouro||""} onChange={e=>setE("logradouro",e.target.value)} placeholder="Rua, Avenida..."/>
            </div>
            <div className="form-group">
              <label className="form-label">Numero</label>
              <input className="form-input" value={endForm.numero||""} onChange={e=>setE("numero",e.target.value)} onBlur={handleNumeroBlurModal}/>
            </div>
            <div className="form-group">
              <label className="form-label">Complemento</label>
              <input className="form-input" value={endForm.complemento||""} onChange={e=>setE("complemento",e.target.value)} placeholder="Apto, sala..."/>
            </div>
            <div className="form-group">
              <label className="form-label">Bairro</label>
              <input className="form-input" value={endForm.bairro||""} onChange={e=>setE("bairro",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Cidade</label>
              <input className="form-input" value={endForm.cidade||""} onChange={e=>setE("cidade",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Estado</label>
              <input className="form-input" value={endForm.estado||""} onChange={e=>setE("estado",e.target.value)} placeholder="SP"/>
            </div>
          </div>
          <div className="form-grid" style={{marginBottom:12}}>
            <div className="form-group">
              <label className="form-label">Latitude</label>
              <input className="form-input" value={endForm.latitude||""} onChange={e=>setE("latitude",e.target.value)} placeholder="-23.550500"/>
            </div>
            <div className="form-group">
              <label className="form-label">Longitude</label>
              <input className="form-input" value={endForm.longitude||""} onChange={e=>setE("longitude",e.target.value)} placeholder="-46.633300"/>
            </div>
            <div className="form-group" style={{display:"flex",alignItems:"flex-end",gridColumn:"span 2"}}>
              <button className="btn btn-secondary" style={{fontSize:12}} onClick={geocodificarAtual} disabled={geocodificando||!endForm.logradouro}>
                <i className="ti ti-map-pin"/> {geocodificando?"Buscando...":"Buscar coordenadas automaticamente"}
              </button>
            </div>
          </div>

          <div className="form-section">Observacoes</div>
          <div className="form-group">
            <textarea className="form-input" rows={3} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/>
          </div>
        </Modal>
      )}
    </>
  );
}
